import { TestRequest } from '@angular/common/http/testing';
import { Directive, Input } from '@angular/core';

//NOTE: You may need to add properties here that are referenced as template variables for the table row. 
//      e.g. expanded is for the row expansion feature  (let-expanded="expanded")
interface TableRowTemplateContext<Titem extends object> {
  $implicit: Titem;
  expanded: any
}

@Directive({
  selector: 'ng-template[appTableRow]',
  standalone: true
})
export class TableRowDirective<Titem extends object> {

  @Input('appTableRow') items!: Titem[];

  static ngTemplateContextGuard<TContextItem extends object>(
    dir: TableRowDirective<TContextItem>,
    ctx: unknown
  ): ctx is TableRowTemplateContext<TContextItem> {
    return true;
  }

}